export default __webpack_public_path__ + "static/media/Pic5.21e35bfd.jpg";